export const css = {
	root: '_3bFvqFRk',
	' _key': 'apic-theme/dojo/accordion'
};

export default css;
